import submitLoader from '@common/Globals/submit-loader';
import multiSelect from '@common/Controls/multi-select';
import multiDate from '@common/Controls/multi-date';
import date from '@common/Controls/date';
import dateRange from '@common/Controls/date-range';
import 'flatpickr/dist/flatpickr.min.css';
import wip from '@common/Globals/wip';
import * as bootstrap from 'bootstrap';

const globalForm = () => $('form');
const sideBarCollapse = () => $('#sidebarCollapse');
const backButton = () => $('.js-back-button');
const allInputs = () => $(':input');

export default function init(): void {
	sideBarCollapse().on('click', toggleSidebar);
	globalForm().on('submit', showSubmitLoader);
	backButton().on('click', goBack);
	allInputs().on('change', removeValidationError);

	for (const el of document.getElementsByClassName('toast')) {
		const toast = new bootstrap.Toast(el);
		toast.show();
	}

	date();
	multiSelect();
	multiDate();
	dateRange();
	wip();
}

function removeValidationError(ev: JQuery.ChangeEvent) {
	const inputId = ev.currentTarget.getAttribute('input-id');

	if (inputId) {
		$(`:input[input-id="${inputId}"]`).removeClass('input-validation-error');
		$(`span[input-id="${inputId}"]`).removeClass('field-validation-error').text(null);
	}
}

// toggles the collapse of the primary nav
async function toggleSidebar() {
	$('#sidebar, #content').toggleClass('active');

	const sidebarCollapsed = $('#sidebar').hasClass('active');
	await fetch('/clientData/setSidebarState', {
		method: 'POST',
		body: JSON.stringify({sidebarCollapsed}),
		headers: {
			'Content-Type': 'application/json',
		}
	});
}


function showSubmitLoader(ev: JQuery.SubmitEvent) {
	submitLoader.show(ev.currentTarget);
}

function goBack() {
	window.history.back();
}

$(init);
